import { Pipe, PipeTransform } from '@angular/core';
import { buildSearchRegex } from './highlight.util';

export interface HighlightSegment {
  readonly text: string;
  readonly matched: boolean;
}

@Pipe({
  name: 'highlight',
})
export class HighlightPipe implements PipeTransform {
  // Splits value into matched/unmatched segments instead of building HTML, so the template can
  // render it via interpolation without a DomSanitizer bypass
  transform(value: string | null | undefined, term: string): HighlightSegment[] {
    const text = value ?? '';
    const regex = buildSearchRegex(term, 'gi');
    if (!regex) {
      return [{ text, matched: false }];
    }

    const segments: HighlightSegment[] = [];
    let lastIndex = 0;

    for (const match of text.matchAll(regex)) {
      if (match.index > lastIndex) {
        segments.push({ text: text.slice(lastIndex, match.index), matched: false });
      }
      segments.push({ text: match[0], matched: true });
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) {
      segments.push({ text: text.slice(lastIndex), matched: false });
    }

    return segments;
  }
}
